import React, { useEffect, useState } from 'react';
import Spinner from '../common/Spinner';
import useModalClose from '../../hooks/useModalClose';
import { getTalepIsAkisi } from '../../services/requestService';
import { formatDateWithHourAndMinute } from '../../helpers/stringHelpers';

const hataMesaji = (err, varsayilan) =>
  err?.response?.data?.message || err?.response?.data?.mesaj || err?.message || varsayilan;

// Aşama → zaman çizelgesindeki işaretin rengi (_talep-akisi.scss).
const ASAMA_SINIFI = {
  'Vatandaş': 'vatandas',
  'Vatandaş Talepleri': 'talepler',
  'Bölge Çavuşu': 'cavus',
  'Personel': 'personel',
  'Sonuçlandırma': 'sonuc',
  'Sistem': 'sistem',
};

/**
 * İş Akışı: talebin oluşturulmasından sonuçlandırılmasına kadar tüm hareketleri, EBYS'deki gibi
 * kronolojik gösterir (kim yaptı, kimden kime, ne yapıldı, durum değişimi, açıklama).
 */
const IsAkisiModal = ({ isOpen, requestId, onClose }) => {
  const [veri, setVeri] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [hata, setHata] = useState(null);

  useModalClose(isOpen, onClose);

  useEffect(() => {
    if (!isOpen || !requestId) return;
    setVeri(null);
    setHata(null);
    setYukleniyor(true);
    getTalepIsAkisi(requestId)
      .then((r) => setVeri(r.data))
      .catch((e) => setHata(hataMesaji(e, 'İş akışı alınamadı.')))
      .finally(() => setYukleniyor(false));
  }, [isOpen, requestId]);

  if (!isOpen) return null;

  const talep = veri?.talep;
  const guncel = veri?.guncel;

  return (
    <div className="modal-overlay">
      <div className="talep-akisi-modal talep-akisi-modal--genis" role="dialog" aria-modal="true" aria-labelledby="is-akisi-baslik">
        <div className="talep-akisi-modal__header">
          <h3 id="is-akisi-baslik">İş Akışı{talep ? ` · #${talep.requestId}` : ''}</h3>
          <button type="button" className="talep-akisi-modal__kapat" onClick={onClose} aria-label="Kapat">×</button>
        </div>

        <div className="talep-akisi-modal__body">
          {yukleniyor && <div className="talep-akisi-modal__bos"><Spinner size="medium" /></div>}
          {hata && <p className="error-message">{hata}</p>}

          {talep && (
            <div className="is-akisi__ozet">
              <div>
                <span className="etiket">Talep</span>
                <span>{talep.kategori}{talep.talep ? ` — ${talep.talep}` : ''}</span>
              </div>
              <div>
                <span className="etiket">Vatandaş / Adres</span>
                <span>{talep.vatandasAdsoyad || '-'} · {talep.adres || '-'}</span>
              </div>
              <div>
                <span className="etiket">Güncel durum</span>
                <span className="talep-durum-rozet" data-durum={talep.durum}>{talep.durum}</span>
                {guncel?.cavus && <span> · Çavuş: <b>{guncel.cavus}</b></span>}
                {guncel?.personel && <span> · Personel: <b>{guncel.personel}</b></span>}
                {guncel?.tamamlanmaTarihi && (
                  <span> · Sonuç: <b>{guncel.sonucIslemTipi}</b> ({guncel.tamamlayan}, {formatDateWithHourAndMinute(guncel.tamamlanmaTarihi)})</span>
                )}
              </div>
            </div>
          )}

          {veri?.adimlar && (
            <ol className="is-akisi__zaman">
              {veri.adimlar.map((a, i) => (
                <li key={i} className={`is-akisi__adim is-akisi__adim--${ASAMA_SINIFI[a.asama] || 'sistem'}`}>
                  <div className="is-akisi__tarih">{formatDateWithHourAndMinute(a.tarih)}</div>
                  <div className="is-akisi__icerik">
                    <div className="is-akisi__baslik">
                      <span className="is-akisi__asama">{a.asama}</span>
                      <b>{a.islem}</b>
                    </div>
                    <div className="is-akisi__kim">
                      {a.yapan && <span>İşlemi yapan: <b>{a.yapan}</b></span>}
                      {(a.kimden || a.kime) && <span>{a.kimden || '-'} → {a.kime || '-'}</span>}
                    </div>
                    {(a.oncekiDurum || a.yeniDurum) && (
                      <div className="is-akisi__durum">
                        {a.oncekiDurum && <span className="talep-durum-rozet" data-durum={a.oncekiDurum}>{a.oncekiDurum}</span>}
                        {a.oncekiDurum && a.yeniDurum && ' → '}
                        {a.yeniDurum && <span className="talep-durum-rozet" data-durum={a.yeniDurum}>{a.yeniDurum}</span>}
                      </div>
                    )}
                    {a.aciklama && <div className="is-akisi__aciklama">{a.aciklama}</div>}
                  </div>
                </li>
              ))}
            </ol>
          )}
        </div>

        <div className="talep-akisi-modal__footer">
          <button type="button" className="talep-akisi-btn talep-akisi-btn--ikincil" onClick={onClose}>Kapat</button>
        </div>
      </div>
    </div>
  );
};

export default IsAkisiModal;
